<template>
	<div>
		<pui-datatable :modelName="modelName" :actions="actions" :modelColumnDefs="columnDefs"></pui-datatable>
		<pui-user-reset-password-dialog v-if="!isLdapActive" :modelName="modelName"></pui-user-reset-password-dialog>
	</div>
</template>

<script>
import PuiUserActions from './PuiUserActions';
import PuiUserResetPasswordDialog from './PuiUserResetPasswordDialog';

export default {
	name: 'PuiUserGrid',
	components: { PuiUserResetPasswordDialog },
	data() {
		return {
			modelName: 'puiuser',
			columnDefs: {
				disabled: {
					render: (data) => {
						if (data === 0) {
							return this.$t('general.no');
						} else {
							return this.$t('general.yes');
						}
					}
				},
				changepasswordnextlogin: {
					render: (data) => {
						if (data === 0) {
							return this.$t('general.no');
						} else {
							return this.$t('general.yes');
						}
					}
				}
			}
		};
	},
	computed: {
		isLdapActive() {
			return this.$store.getters.isLdapActive;
		},
		actions() {
			return this.isLdapActive ? PuiUserActions.actionsLdap : PuiUserActions.actions;
		}
	}
};
</script>
